import { AnimatePresence, motion, useReducedMotion } from "motion/react";
import type { ReactNode } from "react";

export function AnimatedCollapse({
  open,
  children,
  enterDurationMs = 180,
  exitDurationMs = 140,
  enterEasing = [0.2, 0, 0, 1],
  exitEasing = [0.3, 0, 1, 1],
}: {
  open: boolean;
  children: ReactNode;
  enterDurationMs?: number;
  exitDurationMs?: number;
  enterEasing?: [number, number, number, number];
  exitEasing?: [number, number, number, number];
}) {
  const prefersReducedMotion = useReducedMotion();

  if (prefersReducedMotion) {
    return open ? children : null;
  }

  return (
    <AnimatePresence initial={false}>
      {open ? (
        <motion.div
          animate={{ height: "auto", opacity: 1 }}
          className="overflow-hidden"
          exit={{
            height: 0,
            opacity: 0,
            transition: {
              height: { duration: exitDurationMs / 1000, ease: exitEasing },
              opacity: { duration: Math.min(exitDurationMs, 100) / 1000, ease: "easeIn" },
            },
          }}
          initial={{ height: 0, opacity: 0 }}
          transition={{
            height: { duration: enterDurationMs / 1000, ease: enterEasing },
            opacity: { duration: Math.min(enterDurationMs, 160) / 1000, ease: "easeOut" },
          }}
        >
          {children}
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
